import React from 'react';

import { Button as SemanticButton } from 'semantic-ui-react';
import { Button as MaterialButton } from 'material-ui';

import styles from './Button.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

// buttonColor - 헥스 컬러로 넘겨 받은 색상을 버튼에 적용 (ex> buttonColor="a52f01")
// fullColor - 버튼의 배경을 투명하게 할지 꽉채울지 (default:투명 배경 1: 배경 채우기)
// fontSize - 글씨 크기 설정 (숫자 형태로 넘기면 됨 ex> fontSize="14")
// fontColor - 글씨의 색상을 따로 지정하고 싶을 경우에 등록 (ex> fontColor="a52f01")
const Button = ({ children, buttonType, className, buttonColor, fullColor, fontSize, fontColor, ...rest }) => {
  let customStyle = {};
  if (buttonColor) {
    customStyle = {
      // CSS
      border: '1px solid',
      borderColor: buttonColor,
      color: buttonColor,
      backgroundColor: 'transparent'
    };
    if (fullColor) {
      customStyle = {
        // CSS
        borderColor: buttonColor,
        color: '#ffffff',
        backgroundColor: buttonColor
      };
    }
  }

  if (fontSize) {
    customStyle['fontSize'] = fontSize + 'px';
  }

  if (fontColor) {
    customStyle['color'] = fontColor;
  }

  return buttonType === 'material' ? (
    <MaterialButton
      className={cx('material-button', className, { disabled: rest.disabled })}
      {...rest}
      style={customStyle}>
      {children}
    </MaterialButton>
  ) : (
    <SemanticButton className={cx('semantic-button', className)} {...rest} style={customStyle}>
      {children}
    </SemanticButton>
  );
};

Button.propTypes = {};
Button.defaultProps = {};

export default Button;



// WEBPACK FOOTER //
// ./src/script/components/common/Button.js